import Raven from 'raven-js';
import ACBadRequestError from 'academy-common-lib/components/error/ACBadRequestError';
import ACMissingContentError from 'academy-common-lib/components/error/ACMissingContentError';
import ACForbiddenError from 'academy-common-lib/components/error/ACForbiddenError';
import { useEffect } from 'react';
import { ConditionalNavMarker } from '../../features/rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const ApiError = ({
  className,
  error,
  marker404,
  marker403,
  markerDefault,
  resetLink
}) => {
  const status = error && typeof error !== 'string' && (error.status || error.networkError && error.networkError.status) || 404;
  useEffect(() => {
    if (![404, 403].includes(status)) {
      Raven.captureException(error);
    }
  }, [error, status]);
  switch (status) {
    case 404:
      return /*#__PURE__*/_jsx(ConditionalNavMarker, {
        name: marker404,
        children: /*#__PURE__*/_jsx(ACMissingContentError, {
          className: className
        })
      });
    case 403:
      return /*#__PURE__*/_jsx(ConditionalNavMarker, {
        name: marker403,
        children: /*#__PURE__*/_jsx(ACForbiddenError, {
          className: className
        })
      });
    default:
      return /*#__PURE__*/_jsx(ConditionalNavMarker, {
        name: markerDefault,
        children: /*#__PURE__*/_jsx(ACBadRequestError, {
          className: className,
          to: resetLink
        })
      });
  }
};
export default ApiError;